export default import.meta.ROLLDOWN_FILE_URL_BjL40inartz73Fk6ZI3xKg